import { type Theme } from "@mui/material";

const form = {
  MuiFormLabel: {
    styleOverrides: {
      asterisk: ({ theme }: { theme: Theme }) => ({
        color: theme.palette.error.main,
      }),
    },
  },
};

export default form;
